import {EventBroker} from "@frontend/lib/utils/event-broker";

export const EVENTS = {
    SAVED: 'SAVED',
    INIT: 'INIT',
    CLOSED: 'CLOSED',
    BULK_COPY: 'BULK_COPY',
    BULK_RESIZE_SELECTED: 'BULK_RESIZE_SELECTED',
}

export const bulkCopyAndResizeEventBroker = new EventBroker();